<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Requests</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a [routerLink]="[getDashboardRoute()]" href="javascript:void(0);"
              ><i class="ti ti-smart-home"></i
            ></a>
          </li>
          <!-- <li class="breadcrumb-item">
                Employee
              </li> -->
          <li class="breadcrumb-item active" aria-current="page">Requests</li>
        </ol>
      </nav>
    </div>
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
      <div class="me-2 mb-2 d-none">
        <div class="dropdown">
          <a
            href="javascript:void(0);"
            class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
          >
            <i class="ti ti-file-export me-1"></i>Export
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
              >
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-xls me-1"></i>Export as Excel
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="mb-2">
        <a href="javascript:void(0)" class="btn btn-primary d-flex align-items-center"
          ><i class="ti ti-circle-plus me-2"></i>Add Designation</a
        >
      </div> -->
      <div class="head-icons ms-2 d-none">
        <a
          href="javascript:void(0);"
          class=""
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-original-title="Collapse"
          id="collapse-header"
        >
          <i class="ti ti-chevrons-up"></i>
        </a>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <h5>Requests</h5>

      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <div class="me-3">
          <select
            class="form-select form-select-sm col-md-1"
            id="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <!-- <option selected disabled>Show Entries Per Page</option> -->
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
          </select>
        </div>

        <!-- <ng-select
          class="me-3"
          [items]="businesses$ | async"
          bindValue="id"
          placeholder="Select Business Entity"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          style="width: 200px"
          [(ngModel)]="businessId"
          (change)="loadRequests()"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
        </ng-select> -->
        <ng-select
          class="me-3"
          [items]="(businesses$ | async) ?? []"
          bindValue="id"
          placeholder="Select Business Entity"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          style="width: 200px"
          [(ngModel)]="businessId"
          (change)="loadRequests()"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
        </ng-select>

        <div class="me-3">
          <select class="form-select" [(ngModel)]="status" (change)="onStatusChange()">
            <option value="" selected>Select Status</option>
            <option [value]="statusEnum.APPROVED">{{ statusEnum.APPROVED }}</option>
            <option [value]="statusEnum.PENDING">{{ statusEnum.PENDING }}</option>
            <option [value]="statusEnum.REJECTED">{{ statusEnum.REJECTED }}</option>
            <option [value]="statusEnum.CANCELLED">{{ statusEnum.CANCELLED }}</option>
          </select>
        </div>
        <div class="form-sort search-box">
          <label>
            <input
              type="search"
              class="form-control"
              placeholder="Search"
              [(ngModel)]="search"
              (input)="loadRequests(); onStatusChange()"
          /></label>
        </div>
        <!-- Rest of your template -->
      </div>
    </div>
    <div class="card-body p-0">
      <div class="custom-datatable-filter table-responsive">
        <ng-container *ngIf="empRequests$ | async as empRequests">
          <table class="table datatable" *ngIf="empRequests.length > 0; else noRecords">
            <thead class="thead-light">
              <tr>
                <!-- <th class="no-sort"></th> -->
                <th>Employee</th>
                <th>Request By</th>
                <th>Request Type</th>
                <th>Business Entity</th>
                <!-- <th>Request On</th> -->
                <th>No. of Days</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <!-- <tr
                *ngFor="let empRequest of empRequests$ | async"
                [class.selected-row]="selectedRequestId === empRequest.id"
              > -->
              <tr
                *ngFor="let empRequest of empRequests"
                [class.selected-row]="selectedRequestId === empRequest.id"
              >
                <td>
                  <a [routerLink]="['/hrm/employee', empRequest.userId]">
                    {{
                      empRequest.user?.firstName || empRequest.user?.lastName
                        ? (empRequest.user?.firstName || '' | capitalize) +
                          ' ' +
                          (empRequest.user?.lastName || '' | capitalize)
                        : 'N/A'
                    }}
                  </a>
                </td>
                <td>
                  {{ empRequest.requestByUser?.firstName | capitalize }}
                  {{ empRequest.requestByUser?.lastName | capitalize }}
                  <span *ngIf="!empRequest.requestByUser">N/A</span>,
                  {{ empRequest.createdAt | date: 'medium' }}
                </td>
                <td>{{ empRequest.requestType }}</td>
                <!-- <td><span class="badge badge-soft-info">Promotion</span></td>
                      <td>Germany</td>
                      <td>
                        <div class="set-star">
                          <i class="fa fa-star filled me-2"></i>4.2
                        </div>
                      </td> -->
                <td>{{ empRequest.user?.business?.businessName | capitalize }}</td>
                <!-- <td>{{ empRequest.createdAt | date: 'medium' }}</td> -->
                <!-- <td>{{ empRequest.request.length }}</td> -->
                <td>{{ getTotalRequestedDays(empRequest.request) }}</td>

                <td>
                  <span
                    *ngIf="empRequest.status === 'Approved'"
                    class="badge badge-success d-inline-flex align-items-center badge-xs"
                  >
                    {{ empRequest.status }}
                  </span>
                  <span
                    *ngIf="['Cancelled', 'Rejected'].includes(empRequest.status)"
                    class="badge bg-danger d-inline-flex align-items-center badge-xs"
                  >
                    {{ empRequest.status }}
                  </span>

                  <span
                    *ngIf="empRequest.status === 'Pending'"
                    class="badge badge-warning d-inline-flex align-items-center badge-xs"
                  >
                    {{ empRequest.status }}
                  </span>
                </td>
                <td>
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0)"
                      data-bs-toggle="modal"
                      data-bs-target="#view_details"
                      (click)="openOffcanvasAttendance(empRequest)"
                      title="View Detail"
                    >
                      <i class="ti ti-eye"></i>
                    </a>
                    <ng-container *appHasPermission="{ requests: ['edit'] }">
                      <ng-container
                        *ngIf="
                          empRequest.status === 'Pending' &&
                          (isBusinessOwner() || empRequest.userId !== user?.id)
                        "
                      >
                        <!-- <button
                          type="button"
                          class="btn btn-success me-2"
                          (click)="openBlockUnblock(cancelAppliedLeaveModal, empRequest, 'Approve')"
                        >
                          Approve
                        </button>
                        <button
                          type="button"
                          class="btn btn-danger me-2"
                          (click)="openBlockUnblock(cancelAppliedLeaveModal, empRequest, 'Reject')"
                        >
                          Reject
                        </button>

                        <button
                          type="button"
                          class="btn btn-warning"
                          (click)="openBlockUnblock(cancelAppliedLeaveModal, empRequest, 'Cancel')"
                        >
                          Cancel
                        </button> -->

                        <a
                          href="javascript:void(0)"
                          (click)="openBlockUnblock(cancelAppliedLeaveModal, empRequest, 'Approve')"
                          title="Approve"
                        >
                          <i class="ti ti-check text-success"></i>
                        </a>
                        <a
                          href="javascript:void(0)"
                          (click)="openBlockUnblock(cancelAppliedLeaveModal, empRequest, 'Reject')"
                          title="Reject"
                        >
                          <i class="ti ti-ban text-danger"></i>
                        </a>
                      </ng-container>
                    </ng-container>
                    <ng-container *appHasPermission="{ requests: ['delete'] }">
                      <ng-container *ngIf="empRequest.status === 'Pending'">
                        <a
                          href="javascript:void(0)"
                          (click)="openBlockUnblock(cancelAppliedLeaveModal, empRequest, 'Cancel')"
                          title="Cancel"
                        >
                          <i class="ti ti-x text-warning"></i>
                        </a>
                      </ng-container>
                    </ng-container>
                    <!-- <ng-container *appHasPermission="{ user: ['view'] }">
                      <ng-container *ngIf="empRequest.requestByUser.id === user?.id">
                        <ng-container
                          *ngIf="
                            empRequest.status === 'Pending' || empRequest.status === 'Approved'
                          "
                        >
                          <button
                            type="button"
                            class="btn btn-warning"
                            (click)="
                              openBlockUnblock(cancelAppliedLeaveModal, empRequest, 'Cancel')
                            "
                          >
                            Cancel
                          </button>
                        </ng-container>
                      </ng-container>
                    </ng-container> -->
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
        <ng-template #noRecords>
          <div class="text-center">Record not available</div>
        </ng-template>
      </div>
    </div>
    <!-- pagination -->
    <ng-container *ngIf="empRequests$ | async as empRequests">
      <div
        class="d-flex align-items-center justify-content-between ms-2"
        *ngIf="empRequests.length > 0"
      >
        <div>
          Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ currentPage * pageLimit }} of
          {{ totalCount }} entries
        </div>
        <div class="has-text-centered mt-3">
          <app-pagination
            [currentPage]="currentPage"
            [pageSize]="pageLimit"
            [totalRows]="totalCount"
            (pageChange)="onPageChange($event)"
          ></app-pagination>
        </div>
      </div>
    </ng-container>

    <!-- pagination end -->
  </div>
</div>

<ng-template #cancelAppliedLeaveModal let-modal>
  <!-- <div class="modal fade" id="delete_modal">
      <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content"> -->
  <div class="modal-body text-center">
    <span
      class="avatar avatar-xl mb-3"
      [ngClass]="
        blockUnblockStatus !== 'Approve'
          ? 'bg-transparent-danger text-danger'
          : 'bg-transparent-success text-success'
      "
    >
      <i
        [ngClass]="
          blockUnblockStatus !== 'Approve' ? 'ti ti-lock fs-36' : 'ti ti-lock-open-2 fs-36'
        "
      ></i>
    </span>
    <h4 class="mb-1">Confirm {{ blockUnblockStatus }}</h4>
    <p class="mb-3">You want to {{ blockUnblockStatus }} the request.</p>
    <form [formGroup]="form">
      <!-- <div class="col-md-12" *ngIf="blockUnblockStatus !== 'Approve'">
        <div class="mb-3">
          <label class="form-label">Reason</label>
          <textarea class="form-control" rows="3" formControlName="statusReason"></textarea>
          <div *ngIf="form.get('statusReason')?.invalid && form.get('statusReason')?.touched">
            <span class="text-danger">
              {{ getErrorMessage('statusReason') }}
            </span>
          </div>
        </div>
      </div> -->
      <div class="d-flex justify-content-center">
        <a
          href="javascript:void(0);"
          class="btn btn-light me-3"
          data-bs-dismiss="modal"
          (click)="onClose()"
          >Cancel</a
        >
        <a href="javascript:void(0);" class="btn btn-danger" (click)="onSubmit()"
          >Yes, {{ blockUnblockStatus }}</a
        >
      </div>
    </form>
  </div>
  <!-- </div>
      </div>
    </div> -->
</ng-template>

<!-- attendance reqularize details -->
<div
  class="modal fade"
  id="view_details"
  tabindex="-1"
  aria-labelledby="viewDetailsLabel"
  aria-hidden="true"
  data-bs-animation="false"
  (hidden.bs.modal)="onViewDetailsClosed()"
>
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="viewDetailsLabel">Request Details</h5>
        <button
          type="button"
          class="btn-close custom-btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="selectedRequestId = null"
        >
          <i class="ti ti-x"></i>
        </button>
      </div>
      <div class="modal-body" *ngIf="selectedAttendance">
        <p>
          <strong>Name:</strong> {{ selectedAttendance.user.firstName }}
          {{ selectedAttendance.user.lastName }}
        </p>
        <p>
          <strong>Request Type:</strong>
          {{ selectedAttendance.requestType }}
        </p>

        <p>
          <strong>Status:</strong>
          {{ selectedAttendance.status }}
        </p>

        <!-- <p>
          <strong>Requested By:</strong>
          {{ selectedAttendance.requestByUser.firstName | capitalize }}
          {{ selectedAttendance.requestByUser.lastName | capitalize }}
        </p> -->

        <p>
          <strong>Requested By:</strong>
          {{ selectedAttendance.requestByUser.firstName | capitalize }}
          {{ selectedAttendance.requestByUser.lastName | capitalize }},
          {{ selectedAttendance.createdAt | date: 'medium' }}
        </p>

        <p>
          <strong>Employee ID:</strong>
          {{ selectedAttendance.user.empId }}
        </p>

        <p>
          <strong>Business Entity:</strong>
          {{ selectedAttendance.user.business?.businessName | capitalize }}
        </p>

        <!-- <p>
          <strong>Requested On:</strong>
          {{ selectedAttendance.createdAt | date: 'medium' }}
        </p> -->

        <!-- <p *ngIf="selectedAttendance.status === 'Approved' && selectedAttendance.updatedAt">
          <strong>Approved On:</strong>
          {{ selectedAttendance.updatedAt | date: 'medium' }}
        </p> -->

        <p *ngIf="selectedAttendance.status === 'Rejected' && selectedAttendance.updatedAt">
          <strong>Rejected On:</strong>
          {{ selectedAttendance.updatedAt | date: 'medium' }}
        </p>

        <p *ngIf="selectedAttendance.status === 'Cancelled' && selectedAttendance.updatedAt">
          <strong>Cancelled On:</strong>
          {{ selectedAttendance.updatedAt | date: 'medium' }}
        </p>

        <p *ngIf="selectedAttendance.approver">
          <strong>
            {{
              selectedAttendance.status === 'Approved'
                ? 'Approved By'
                : selectedAttendance.status === 'Rejected'
                  ? 'Rejected By'
                  : selectedAttendance.status === 'Cancelled'
                    ? 'Cancelled By'
                    : 'Action By'
            }}:
          </strong>
          {{ selectedAttendance.approver.firstName | capitalize }}
          {{ selectedAttendance.approver.lastName | capitalize }},
          {{ selectedAttendance.updatedAt | date: 'medium' }}
        </p>
        <!-- <p><strong>Date:</strong> {{ selectedAttendance.date | date: 'medium' }}</p>
        <p><strong>Clock In:</strong> {{ selectedAttendance.clockIn | date: 'shortTime' }}</p>
        <p><strong>Clock Out:</strong> {{ selectedAttendance.clockOut | date: 'shortTime' }}</p> -->

        <div *ngIf="selectedAttendance.request?.length > 0">
          <hr />
          <h6 class="mt-2">Requested Dates:</h6>
          <ul class="list-group">
            <li
              *ngFor="let req of selectedAttendance.request"
              class="list-group-item d-flex justify-content-between"
            >
              <span>
                <strong>Date:</strong> {{ req.date }}&nbsp;&nbsp;
                <!-- <br /> -->
                <!-- <strong>Clock In:</strong> {{ req.startTime | date: 'shortTime' }}<br />
                <strong>Clock Out:</strong> {{ req.endTime | date: 'shortTime' }}<br /> -->
                <strong>Day:</strong>
                {{ req.selectionType === 'FullDay' ? 'Full Day' : req.halfDayOption }}<br />
                <ng-container *ngIf="getClockInOut(req.date) as attendance; else noAttendance">
                  <strong>Clock In:</strong>
                  {{
                    getClockInOut(req.date)?.clockIn
                      ? (getClockInOut(req.date).clockIn | date: 'shortTime')
                      : 'null'
                  }}&nbsp;&nbsp;

                  <strong>Clock Out:</strong>
                  {{
                    getClockInOut(req.date)?.clockOut
                      ? (getClockInOut(req.date).clockOut | date: 'shortTime')
                      : 'null'
                  }}&nbsp;&nbsp;
                  <strong>Work Hour:</strong>
                  {{ getClockInOut(req.date)?.workHour || 'null' }}
                </ng-container>

                <ng-template #noAttendance>
                  <strong>Clock In:</strong> null &nbsp;&nbsp; <strong>Clock Out:</strong> null
                  &nbsp;&nbsp; <strong>Work Hour:</strong> null
                </ng-template>
              </span>
            </li>
          </ul>
        </div>
        <!-- Add more fields as needed -->
      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div> -->
    </div>
  </div>
</div>

<!-- end attendance regularize details -->
